"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _reactWaypoint = require("react-waypoint");

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _functional_utility = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var PartyRoleNameListingCard = function (_React$PureComponent) {
  _inherits(PartyRoleNameListingCard, _React$PureComponent);

  function PartyRoleNameListingCard(props) {
    _classCallCheck(this, PartyRoleNameListingCard);

    var _this = _possibleConstructorReturn(this, (PartyRoleNameListingCard.__proto__ || Object.getPrototypeOf(PartyRoleNameListingCard)).call(this, props));

    _this.renderData = _this.renderData.bind(_this);
    return _this;
  }

  _createClass(PartyRoleNameListingCard, [{
    key: "renderRow",
    value: function renderRow(data) {
      var _this2 = this;

      var markupArr = [];
      mapIndexed(function (item, index) {
        var row = [];
        row.push(_react2.default.createElement(
          "div",
          { key: _this2.props.id + '-row-' + index, "data-testid": _this2.props.id + ("-" + index), className: "display-inline-block" },
          _react2.default.createElement(
            "span",
            { className: "" },
            item
          )
        ));
        markupArr.push(_react2.default.createElement(
          "div",
          { "data-testid": _this2.props.id + '-row', key: _this2.props.id + '-row-' + index, className: "row-divider" },
          row
        ));
      }, data);
      return markupArr;
    }
  }, {
    key: "renderData",
    value: function renderData() {
      var data = this.props.data;
      if (data.length < 2 || this.props.breakpoint < 3) {
        return _react2.default.createElement(
          "div",
          { "data-testid": "one-col-layout", className: "category" },
          _react2.default.createElement(
            "div",
            null,
            this.renderRow(data)
          )
        );
      }

      var dataArr = (0, _ramda.splitAt)(Math.round(this.props.data.length / 2), data);
      return _react2.default.createElement(
        "div",
        { "data-testid": "two-col-layout", className: "category" },
        _react2.default.createElement(
          "div",
          { className: "display-inline-block width-percent-48 text-top" },
          this.renderRow(dataArr[0])
        ),
        _react2.default.createElement("div", { className: "display-inline-block width-percent-4 text-top" }),
        _react2.default.createElement(
          "div",
          { className: "display-inline-block width-percent-48 text-top" },
          this.renderRow(dataArr[1])
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.data)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: this.props.componentId + "-child-card" },
        this.props.activeCardHandler ? _react2.default.createElement(_reactWaypoint2.default, { topOffset: "35%", bottomOffset: "80%",
          onEnter: this.props.activeCardHandler.bind(this, this.props.id) }) : null,
        _react2.default.createElement(
          _card_component2.default,
          {
            dataTest: this.props.id + '-card',
            headerTitle: this.props.headerTitle,
            headerTitleLabel: this.props.headerTitleId,
            headerTitleId: this.props.id,
            breakpoint: this.props.breakpoint
          },
          this.renderData()
        )
      );
    }
  }]);

  return PartyRoleNameListingCard;
}(_react2.default.PureComponent);

exports.default = PartyRoleNameListingCard;